import React, { useContext, useEffect } from "react";
import { Box, Button, Container, Grid, Typography } from "@material-ui/core";
import useBackButtonRedirect from "../../hooks/useBackButton";
import { Link, useNavigate } from "react-router-dom";
import SectionHeader from "../../components/SectionHeader";
import { AuthContext } from "../../auth/AuthContext";

export default function EmailChangeComplete() {
  useBackButtonRedirect();
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (currentUser === undefined) {
      return;
    }
    if (!currentUser) {
      navigate("/login", {
        state: {
          from: window.location.pathname,
          search: window.location.search,
        },
      });
    }
    document.title = "メールアドレス変更完了画面 | じぶん専用IT相談室";
  }, [currentUser]);
  return (
    <Box className="section bg-dots" component={"section"}>
      <Container className="container">
        <Grid container justifyContent="center">
          <Grid item md={6} style={{ textAlign: "center" }}>
            <SectionHeader
              currentPage={"メールアドレスの変更が<br/>完了いたしました"}
              preHeading={"Email Changed"}
            />
            <Typography style={{ marginTop: "2rem" }}>
              メールアドレスの変更が完了いたしました
            </Typography>
            <Link to={"/login"}>
              <button className="classification-btn">ホームへ</button>
            </Link>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
